// New design system component: numbered-circle wizard step icon + connector for MUI Stepper.
// Drop-in replacements for the Colorlib exports in layouts/merchants/new/stepper.js.

import PropTypes from "prop-types";
import { Check } from "@mui/icons-material";
import StepConnector, { stepConnectorClasses } from "@mui/material/StepConnector";
import { styled } from "@mui/material/styles";

export const WizardConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 17,
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundColor: theme.palette.info.main,
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundColor: theme.palette.info.main,
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 2,
    border: 0,
    backgroundColor: theme.palette.grey[400],
    borderRadius: 1,
  },
}));

const WizardStepIconRoot = styled("div")(({ theme, ownerState }) => ({
  backgroundColor: theme.palette.background.default,
  border: `2px solid ${theme.palette.grey[400]}`,
  zIndex: 1,
  color: theme.palette.text.muted || theme.palette.text.secondary,
  fontWeight: 700,
  fontSize: 13,
  width: 34,
  height: 34,
  display: "flex",
  borderRadius: "50%",
  justifyContent: "center",
  alignItems: "center",
  transition: "all 150ms ease",
  ...((ownerState.active || ownerState.completed) && {
    backgroundColor: theme.palette.info.main,
    borderColor: theme.palette.info.main,
    color: theme.palette.white.main,
  }),
}));

export function WizardStepIcon(props) {
  const { active, completed, className, icon } = props;

  return (
    <WizardStepIconRoot ownerState={{ completed, active }} className={className}>
      {completed ? <Check sx={{ fontSize: 18 }} /> : String(icon)}
    </WizardStepIconRoot>
  );
}

WizardStepIcon.defaultProps = {
  active: false,
  completed: false,
  className: "",
  icon: null,
};

WizardStepIcon.propTypes = {
  active: PropTypes.bool,
  completed: PropTypes.bool,
  className: PropTypes.string,
  icon: PropTypes.node,
};
